export const routes = [
	{
		id: 'atlantic',
		data: null,
		color: '#fcdc07',
		url: WPURLS.themeurl + '/assets/js/vue/tent/atlantic.json',
		name: 'Atlantic',
	},
	{
		id: 'northsea-rine-mediterranean',
		data: null,
		color: '#006938',
		url: WPURLS.themeurl + '/assets/js/vue/tent/northsea-rine-mediterranean.json',
		name: 'North Sea-Rhine-Mediterranean',
	},
	{
		id: 'north-sea-baltic',
		data: null,
		color: '#eb2227',
		url: WPURLS.themeurl + '/assets/js/vue/tent/north-sea-baltic.json',
		name: 'North Sea-Baltic',
	},
	{
		id: 'scandinavian-mediterranean',
		data: null,
		color: '#ed4193',
		url: WPURLS.themeurl + '/assets/js/vue/tent/scandinavian-mediterranean.json',
		name: 'Scandinavian-Mediterranean',
	},
	{
		id: 'baltic-sea-adriatic-sea',
		data: null,
		color: '#36499b',
		url: WPURLS.themeurl + '/assets/js/vue/tent/baltic-sea-adriatic-sea.json',
		name: 'Baltic Sea-Adriatic Sea',
	},
	{
		id: 'rhine-danube',
		data: null,
		color: '#26badb',
		url: WPURLS.themeurl + '/assets/js/vue/tent/rhine-danube.json',
		name: 'Rhine-Danube',
	},
	{
		id: 'mediterranean',
		data: null,
		color: '#d7de28',
		url: WPURLS.themeurl + '/assets/js/vue/tent/mediterranean.json',
		name: 'Mediterranean',
	},
	{
		id: 'western-balkans-eastern-mediterranean',
		data: null,
		color: '#8b4e21',
		url: WPURLS.themeurl + '/assets/js/vue/tent/western-balkans-eastern-mediterranean.json',
		name: 'Western Balkans-Eastern Mediterranean',
	},
	{
		id: 'baltic-sea-black-sea-aegean-sea',
		data: null,
		color: '#7e52a1',
		url: WPURLS.themeurl + '/assets/js/vue/tent/baltic-sea-black-sea-aegean-sea.json',
		name: 'Baltic Sea-Black Sea-Aegean Sea',
	},
];
